module.exports = __webpack_public_path__ + "static/media/customers_mo.2209e90d.png";